module.exports = __webpack_public_path__ + "img/miss-zdrava-logo.b9a72231.svg";